// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* #ce1126 #15489c */
/* loading */
.loading {
  text-align: center;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading h2 {
  color: #15489c;
  font-weight: bold;
  font-size: 33px;
}
.loading h2 span {
  color: #ce1126;
}
.loading img {
  width: 100px;
}
/*header styling start  */
.header {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  background-color: #fff;
}
.nav {
  width: 90%;
  margin: auto;
}
.left_logo h3 {
  font-size: 25px;
  font-family: serif;
  font-weight: 550;
  color: #ce1126;
  text-transform: uppercase;
  margin-top: -4px;
}
.left_logo p {
  font-size: 15px;
  font-family: serif;
  margin-top: -13px;
  padding-left: 14px;
  /* color: #ce1126; */
  color: #15489c;
}

.left_logo {
  display: flex;
  margin-top: 15px;
  margin-bottom: -13px;
}
.left_logo img {
  height: 55px;
  margin-top: -13px !important;
}
.header .nav_link {
  text-transform: uppercase;
  font-family: arial;
  padding: 23px 10px;
  margin: auto 5px;
  font-size: 14px;
  font-weight: 550;
  color: #15489c;
  cursor: pointer;
  position: relative;
}
.header .nav_link:hover {
  color: #ce1126;
}
.nav_dropdown {
  position: absolute;
  list-style: none;
  background-color: #4c87db;
  color: #fff;
  left: -25px;
  padding: 20px 15px;
  text-transform: capitalize;
  width: 240px;
  margin-top: 22px;
  display: none;
  z-index: 1000;
}
.nav_dropdown.intro {
  width: 190px;
}
.header .nav_link:hover .nav_dropdown {
  display: block;
}
.nav_dropdown .drop_link {
  padding: 7px 8px;
}
.nav_dropdown .drop_link:hover {
  background-color: rgb(0 114 188);
  color: #fff;
}
.mini {
  width: 210px;
}
@media screen and (max-width: 1320px) {
  .nav {
    width: 95%;
  }
}
@media screen and (max-width: 1200px) {
  .nav {
    width: 98%;
  }
}
@media screen and (max-width: 1095px) {
  .nav {
    width: 95%;
  }
  .header .nav_link {
    padding: 23px 6px;
  }
}
/*header styling end  */
/* carousel styling strt */
.carousel_hero .carousel {
  position: relative;
  width: 80%;
  margin: auto;
  height: 580px;
  overflow: hidden;
}
.carousel_hero img {
  height: auto;
  height: 580px;
  /* overflow: hidden; */
}
.carousel_hero .carousel-indicators {
  position: absolute;
  background-color: #fff;
  width: 100%;
  right: 0;
  bottom: -20px;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: right;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 0%;
}
.carousel_hero .carousel-indicators [data-bs-target] {
  width: 15px !important;
  height: 15px !important;
  background-color: #15489c !important;
  z-index: 2;
}
.carousel-caption {
  position: absolute;
  background-color: #15489c !important;
  opacity: 0.9;
  bottom: 20px !important;
  padding: 15px 10px !important;
}
@media screen and (max-width: 1320px) {
  .carousel_hero .carousel {
    width: 83%;
  }
}
@media screen and (max-width: 1200px) {
  .carousel_hero .carousel {
    height: 550px;
    width: 90%;
  }
  .carousel_hero img {
    height: 550px;
  }
}
@media screen and (max-width: 1095px) {
  .carousel_hero .carousel {
    width: 95%;
  }
}
@media screen and (max-width: 850px) {
  .carousel_hero .carousel {
    height: 450px;
  }
  .carousel_hero img {
    height: 450px;
  }
}
@media screen and (max-width: 650px) {
  .carousel_hero .carousel {
    height: 350px;
  }
  .carousel_hero img {
    height: 350px;
  }
  .carousel-caption {
    display: none;
  }
  .carousel_hero .carousel-indicators {
    justify-content: center;
  }
  .carousel_hero .carousel-indicators [data-bs-target] {
    width: 10px !important;
    height: 10px !important;
  }
}
@media screen and (max-width: 400px) {
  .carousel_hero .carousel {
    height: 250px;
  }
  .carousel_hero img {
    height: 250px;
  }
}
/* carousel styling end */

/* Home styling start */
.youtube {
  height: 360px;
}
.ifc {
  width: 310px;
  margin: auto;
}
@media screen and (max-width: 924px) {
  .youtube {
    height: 195px;
  }
  .video {
    padding-left: 20px;
  }
  .editions,
  .glance,
  .focus {
    display: none;
  }
  .pimg {
    width: 220px !important;
  }
  .nbi {
    height: 80px !important;
    width: 290px !important;
  }
  .ifc {
    width: 210px;
  }
}
.welcome {
  width: 85%;
  margin: auto;
  background-color: #0b76bc;
}
.welcome iframe {
  border-radius: 20px;
}
.welcome h2 {
  font-size: 33px;
  font-family: serif;
  font-weight: 550;
  color: #fff;
  text-transform: uppercase;
}
.welcome h2::after {
  content: "";
  width: 50px;
  border-bottom: 4px solid #fff;
  display: block;
}

.button button {
  background-color: #284e9c;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  height: 35px;
  margin-left: 20px;
  padding: 0 20px;
}
.button button:hover {
  background-color: #ce1126 !important;
}
.welcome .text h5 {
  font-size: 25px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #fff;
}
.welcome .text p {
  text-align: justify;
  font-family: "Karla", sans-serif;
  font-weight: 400;
  font-size: 17px;
  color: #fff;
}
@media screen and (max-width: 1200px) {
  .welcome {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .welcome {
    width: 95%;
  }
  .welcome h2 {
    font-size: 25px;
  }
}
@media screen and (max-width: 800px) {
  .welcome {
    width: 95%;
  }
}
/* welcome styling end */
/* initiative styling start */
.init {
  width: 85%;
  margin: auto;
}
.head h2 {
  text-align: center;
  text-transform: uppercase;
  font-family: serif;
  font-weight: 550;
  color: #ce1126;
}
.head h2::after {
  content: "";
  width: 60px;
  margin: 5px auto;
  border-bottom: 4px solid #15489c;
  display: block;
}
.initiative h3 {
  font-family: serif;
  color: #15489c;
  font-weight: 550;
}
.initiative p {
  text-align: justify;
  font-size: 17px;
}
.imageSlider img {
  height: 385px;
}
.init .carousel-control-next,
.init .carousel-control-prev {
  display: none;
}

.init .carousel-indicators [data-bs-target] {
  width: 12px;
  height: 12px;
  background-color: #15489c;
}
.init .carousel-indicators {
  bottom: -70px;
}
@media screen and (max-width: 1200px) {
  .init {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .init {
    width: 95%;
  }
}
@media screen and (max-width: 800px) {
  .init {
    width: 95%;
  }
  .imageSlider img {
    height: 253px;
  }
}
/* initiative styling end */
/* profession styling start */
.profession {
  width: 85%;
  margin: auto;
  background-color: #f2f2f2;
  overflow-x: hidden;
}

.ecard {
  background-color: #fff;
  padding: 20px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  margin: 0 10px;
}
.ecard h3 {
  font-family: serif;
  color: #15489c;
  font-weight: 550;
}
.slick-dots {
  bottom: -25px;
}

.slick-dots li button:before {
  width: 10px;
  height: 10px;
  content: "";
  display: block;
  background-color: #ce1126;
}
@media screen and (max-width: 1200px) {
  .profession {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .profession {
    width: 95%;
  }
}

/* profession styling end */
/* crs styling start */

.crs {
  width: 85%;
  margin: auto;
  position: relative;
}
.crss {
  background-color: #284e9c;
}
.crs h2 {
  color: #284e9c;
  border-bottom: 2px solid #ce1126;
}
.crs-flex {
  display: flex !important;
}
.crs .image {
  width: 60%;
  margin: auto;
}
.crs .image img {
  width: 100%;
  height: 325px;
}
.crs .content {
  width: 40%;
  margin: auto;
  padding: 20px 30px;
  background-color: #15489c;
}
.crs .content h3 {
  color: #fff;
  text-align: center;
}
.crs .content p {
  text-align: justify;
  color: #fff;
  font-size: 16px;
}
.crs .content button {
  border: none;
  color: #15489c;
  padding: 3px 7px;
}
.crsicon {
  display: flex;
  justify-content: end;
}
.crsicon .icon {
  height: 45px;
  width: 45px;
  border: 2px solid #fff;
  border-radius: 50%;
  text-align: center;
  margin: 0px 7px;
}
.crsicon .cicon {
  color: #fff;
  margin-top: 12px;
}
.crsicon .cicon {
  font-size: 18px;
}
.crs .carousel-control-next-icon,
.crs .carousel-control-prev-icon,
.carousel_hero .carousel-control-next-icon,
.carousel_hero .carousel-control-prev-icon {
  display: none;
}
.crs .carousel-indicators [data-bs-target] {
  width: 10px;
  height: 10px;
}
.crs .carousel-indicators button {
  /* position: relative; */
  background-color: #ce1126;
}
.crs .carousel-indicators {
  position: absolute;
  top: -55px;
  left: 65%;
}

@media screen and (max-width: 1200px) {
  .crs {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .crs {
    width: 95%;
  }
  .crs .image {
    width: 55%;
  }
  .crs .content {
    width: 45%;
  }
}
@media screen and (max-width: 800px) {
  .crs {
    width: 95%;
  }
  .crs .carousel-indicators {
    left: 55%;
  }
}
@media screen and (max-width: 760px) {
  .crs-flex {
    display: flex !important;
    flex-direction: column;
  }
  .crs .image {
    width: 100%;
  }
  .crs .content {
    width: 100%;
  }
}
@media screen and (max-width: 500px) {
  .crs .image {
    height: 200px;
  }
  .crs .image img {
    height: 200px;
  }
}

/* crs styling end */
/* sci styling start */
.sci {
  width: 85%;
  margin: auto;
  background-color: #f2f2f2;
}
.sci .nav {
  background-color: #15489c !important;
  width: 100%;
}

.sci .nav-item {
  width: 150px !important;
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
}

.sci .nav-pills .nav-link.active,
.sci .nav-pills .show > .nav-link {
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #ce1126 !important;
}
.sci .nav-pills {
  --bs-nav-pills-border-radius: 0 !important;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #ce1126 !important;
}
.sci .nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: 20px !important;
  /* font-weight: 550 !important; */
  color: #fff !important;
  text-decoration: none;
  text-transform: uppercase;
}

.view_more {
  text-align: center;
}
.view_more button {
  border: none;
  background-color: #15489c;
  color: #fff;
  border: none;
  padding: 10px 25px;
}
@media screen and (max-width: 1200px) {
  .sci {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .sci {
    width: 95%;
  }
}
@media screen and (max-width: 800px) {
  .sci {
    width: 95%;
  }
  .sci h2 {
    font-size: 22px;
  }
}
@media screen and (max-width: 500px) {
  .sci h2 {
    font-size: 19px;
  }
  .sci .nav {
    --bs-nav-link-padding-x: 0.4rem;
    --bs-nav-link-padding-y: 0.3rem;
  }

  .sci .nav-item {
    width: 114px !important;
  }
  .sci .nav-link {
    font-size: 18px !important;
  }
}

/* sci styling end */
/* news styling start */

.news-room {
  background-color: #fff !important;
  width: 95%;
  margin: auto;
}
.news-room h3 {
  text-align: center;
  color: #ce1126;
  font-weight: bold;
}
.news-room h3::after {
  content: "";
  width: 70px;
  margin: 5px auto 0px auto;
  display: block;
  border-bottom: 3.5px solid #15489c;
}
.news-room .news-card {
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.news-room .news-card img {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.news-room .news-content {
  padding: 10px;
}

.news-room .news-card h5 {
  color: #284e9c;
}

/* news styling end */

/* get involved styling start */
.get_involved {
  width: 85%;
  margin: auto;
  background-color: #f2f2f2;
}
.get_involved .form {
  width: 65%;
  margin: auto;
}
.get_involved .head {
  text-align: center;
}
.get_involved .head h2 {
  font-size: 22px;
}
.get_involved .head h3 {
  font-size: 30px;
  color: #15489c;
  font-weight: 550;
}
.get_involved .head h2::after {
  border-bottom: 2px solid #ce1126;
}

.get_involved .input_check .input {
  display: grid;
  grid-template-columns: 50% 50%;
  justify-content: space-between;
}
.get_involved .input_check .checkbox {
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 0px 10px;
  justify-content: space-between;
  margin: auto;
}

.get_involved input[type="text"] {
  width: 100%;
  margin: auto 0px;
  padding: 9px 10px;
}

.get_involved .input_label {
  margin-bottom: 10px;
  margin: 10px 5px;
}
.get_involved input::placeholder {
  text-transform: uppercase;
  font-size: 18px;
}
.get_involved label {
  padding-left: 5px;
  color: #595757;
  font-weight: 550;
}
.get_involved .agree {
  font-weight: 500 !important;
  color: #284e9c;
}
.register_button {
  text-align: center;
}
.register_button button {
  width: 80%;
  margin: auto;
  border: none;
  font-size: 20px;
  text-transform: uppercase;
  padding: 8px;
  background: #284e9c;
  color: #fff;
  font-weight: 550;
}
@media screen and (max-width: 1200px) {
  .get_involved {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .get_involved {
    width: 95%;
  }
  .get_involved .form {
    width: 75%;
  }
}
@media screen and (max-width: 800px) {
  .get_involved {
    width: 95%;
  }
  .get_involved .form {
    width: 100%;
  }
}
@media screen and (max-width: 625px) {
  .get_involved .input_check .input {
    grid-template-columns: 98%;
  }
  .get_involved .input_check .checkbox {
    grid-template-columns: 100%;
  }
  .get_involved .head h3 {
    font-size: 20px;
    color: #15489c;
  }
  .get_involved input::placeholder {
    font-size: 14px;
  }
  .get_involved label {
    font-size: 14px;
  }
  .register_button button {
    font-size: 16px;
  }
}

/* get involved styling end */
/* footer stying start */
.footer {
  background-color: rgb(8, 69, 112);
}
.footer-section {
  display: flex;
  flex-wrap: wrap;
}
.footer-section h4 {
  font-size: 30px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  color: rgb(22 98 154);
  font-weight: bold;
  color: #fff;
}
.footer-section ul li {
  list-style: none;
  font-size: 17px;
  font-weight: 550;
  color: #fff;
}
.footer-social-icon {
  display: flex;
}
.footer-social-icon li {
  height: 40px;
  width: 50px;
  background-color: rgb(0 114 188);
  margin: 10px;
  color: #fff;
  list-style: none;
  text-align: center;
  padding-top: 4px;
  cursor: pointer;
}
.footer-social-icon li:hover {
  background-color: #fff;
  color: #000;
}
.copy-right {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.powered_by a {
  color: rgb(0 114 188);
  text-decoration: none;
}
.footer-logo h2 {
  color: #fff;
  padding-left: 30px;
}
@media screen and (max-width: 940px) {
  .footer-section {
    justify-content: center;
  }
  .footer-contact {
    text-align: center;
  }
  .footer-social-icon {
    justify-content: space-evenly;
  }
}

/* About section styling start */

.about {
  width: 85%;
  margin: auto;
}
.about-head {
  display: flex;
}
.about-head h3 {
  font-size: 35px;
  color: #15489c;
}
.about-head p {
  font-size: 15px;
  color: #ce1126;
}
.about-head .star_icon .star {
  font-size: 15px;
  color: #ce1126;
  margin-top: 17px;
}
.about .content p {
  font-size: 16px;
  text-align: justify;
}
.about .a_video {
  height: 500px;
}

/* contact section styling start */
.contact_section {
  width: 85%;
  margin: auto;
}
.contact_section h2 {
  font-size: 27px;
  text-align: center;
  color: #15489c;
  font-weight: 650;
}
.contact_section h2::after {
  content: "";
  width: 50px;
  border-bottom: 3px solid #ce1126;
  display: block;
  margin: 5px auto;
}
.contact_section input,
.contact_section textarea {
  padding: 8px 10px;
  border: 1px solid #15489c;
  outline: none;
}
.contact_section .input_contact_label {
  padding: 10px 0px;
}
.contact_section label {
  font-size: 15px;
  color: #4a4949;
  margin-bottom: 10px;
}
.contact_button button {
  border: none;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 550;
  padding: 10px 30px;
  background-color: #15489c;
  color: #fff;
}

@media screen and (max-width: 1200px) {
  .about,
  .contact_section {
    width: 90%;
  }
}
@media screen and (max-width: 1095px) {
  .about,
  .contact_section {
    width: 95%;
  }
}
@media screen and (max-width: 800px) {
  .about,
  .contact_section {
    width: 97%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA,yBAAyB;AACzB;EACE;uCACqC;EACrC,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;AACF;AACA,uBAAuB;AACvB,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,QAAQ;EACR,aAAa;EACb,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA,yBAAyB;;AAEzB,uBAAuB;AACvB;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;;;IAGE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,yCAAyC;EACzC,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA,wBAAwB;AACxB,6BAA6B;AAC7B;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA,2BAA2B;AAC3B,6BAA6B;AAC7B;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb;uCACqC;EACrC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B,sBAAsB;;AAEtB;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB,sBAAsB;AACtB;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,sCAAsC;EACtC,iDAAiD;AACnD;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,kEAAkE;EAClE,0BAA0B;EAC1B,iCAAiC;EACjC,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,+BAA+B;IAC/B,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB,uBAAuB;;AAEvB;EACE,iCAAiC;EACjC,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;;AAErB,+BAA+B;AAC/B;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B,wBAAwB;AACxB;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,wEAAwE;EACxE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,gCAAgC;;AAEhC;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;EACE;;IAEE,UAAU;EACZ;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* #ce1126 #15489c */\n/* loading */\n.loading {\n  text-align: center;\n  height: 90vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.loading h2 {\n  color: #15489c;\n  font-weight: bold;\n  font-size: 33px;\n}\n.loading h2 span {\n  color: #ce1126;\n}\n.loading img {\n  width: 100px;\n}\n/*header styling start  */\n.header {\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,\n    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;\n  background-color: #fff;\n}\n.nav {\n  width: 90%;\n  margin: auto;\n}\n.left_logo h3 {\n  font-size: 25px;\n  font-family: serif;\n  font-weight: 550;\n  color: #ce1126;\n  text-transform: uppercase;\n  margin-top: -4px;\n}\n.left_logo p {\n  font-size: 15px;\n  font-family: serif;\n  margin-top: -13px;\n  padding-left: 14px;\n  /* color: #ce1126; */\n  color: #15489c;\n}\n\n.left_logo {\n  display: flex;\n  margin-top: 15px;\n  margin-bottom: -13px;\n}\n.left_logo img {\n  height: 55px;\n  margin-top: -13px !important;\n}\n.header .nav_link {\n  text-transform: uppercase;\n  font-family: arial;\n  padding: 23px 10px;\n  margin: auto 5px;\n  font-size: 14px;\n  font-weight: 550;\n  color: #15489c;\n  cursor: pointer;\n  position: relative;\n}\n.header .nav_link:hover {\n  color: #ce1126;\n}\n.nav_dropdown {\n  position: absolute;\n  list-style: none;\n  background-color: #4c87db;\n  color: #fff;\n  left: -25px;\n  padding: 20px 15px;\n  text-transform: capitalize;\n  width: 240px;\n  margin-top: 22px;\n  display: none;\n  z-index: 1000;\n}\n.nav_dropdown.intro {\n  width: 190px;\n}\n.header .nav_link:hover .nav_dropdown {\n  display: block;\n}\n.nav_dropdown .drop_link {\n  padding: 7px 8px;\n}\n.nav_dropdown .drop_link:hover {\n  background-color: rgb(0 114 188);\n  color: #fff;\n}\n.mini {\n  width: 210px;\n}\n@media screen and (max-width: 1320px) {\n  .nav {\n    width: 95%;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .nav {\n    width: 98%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .nav {\n    width: 95%;\n  }\n  .header .nav_link {\n    padding: 23px 6px;\n  }\n}\n/*header styling end  */\n/* carousel styling strt */\n.carousel_hero .carousel {\n  position: relative;\n  width: 80%;\n  margin: auto;\n  height: 580px;\n  overflow: hidden;\n}\n.carousel_hero img {\n  height: auto;\n  height: 580px;\n  /* overflow: hidden; */\n}\n.carousel_hero .carousel-indicators {\n  position: absolute;\n  background-color: #fff;\n  width: 100%;\n  right: 0;\n  bottom: -20px;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: right;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 0%;\n}\n.carousel_hero .carousel-indicators [data-bs-target] {\n  width: 15px !important;\n  height: 15px !important;\n  background-color: #15489c !important;\n  z-index: 2;\n}\n.carousel-caption {\n  position: absolute;\n  background-color: #15489c !important;\n  opacity: 0.9;\n  bottom: 20px !important;\n  padding: 15px 10px !important;\n}\n@media screen and (max-width: 1320px) {\n  .carousel_hero .carousel {\n    width: 83%;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .carousel_hero .carousel {\n    height: 550px;\n    width: 90%;\n  }\n  .carousel_hero img {\n    height: 550px;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .carousel_hero .carousel {\n    width: 95%;\n  }\n}\n@media screen and (max-width: 850px) {\n  .carousel_hero .carousel {\n    height: 450px;\n  }\n  .carousel_hero img {\n    height: 450px;\n  }\n}\n@media screen and (max-width: 650px) {\n  .carousel_hero .carousel {\n    height: 350px;\n  }\n  .carousel_hero img {\n    height: 350px;\n  }\n  .carousel-caption {\n    display: none;\n  }\n  .carousel_hero .carousel-indicators {\n    justify-content: center;\n  }\n  .carousel_hero .carousel-indicators [data-bs-target] {\n    width: 10px !important;\n    height: 10px !important;\n  }\n}\n@media screen and (max-width: 400px) {\n  .carousel_hero .carousel {\n    height: 250px;\n  }\n  .carousel_hero img {\n    height: 250px;\n  }\n}\n/* carousel styling end */\n\n/* Home styling start */\n.youtube {\n  height: 360px;\n}\n.ifc {\n  width: 310px;\n  margin: auto;\n}\n@media screen and (max-width: 924px) {\n  .youtube {\n    height: 195px;\n  }\n  .video {\n    padding-left: 20px;\n  }\n  .editions,\n  .glance,\n  .focus {\n    display: none;\n  }\n  .pimg {\n    width: 220px !important;\n  }\n  .nbi {\n    height: 80px !important;\n    width: 290px !important;\n  }\n  .ifc {\n    width: 210px;\n  }\n}\n.welcome {\n  width: 85%;\n  margin: auto;\n  background-color: #0b76bc;\n}\n.welcome iframe {\n  border-radius: 20px;\n}\n.welcome h2 {\n  font-size: 33px;\n  font-family: serif;\n  font-weight: 550;\n  color: #fff;\n  text-transform: uppercase;\n}\n.welcome h2::after {\n  content: \"\";\n  width: 50px;\n  border-bottom: 4px solid #fff;\n  display: block;\n}\n\n.button button {\n  background-color: #284e9c;\n  border: none;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 14px;\n  height: 35px;\n  margin-left: 20px;\n  padding: 0 20px;\n}\n.button button:hover {\n  background-color: #ce1126 !important;\n}\n.welcome .text h5 {\n  font-size: 25px;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  color: #fff;\n}\n.welcome .text p {\n  text-align: justify;\n  font-family: \"Karla\", sans-serif;\n  font-weight: 400;\n  font-size: 17px;\n  color: #fff;\n}\n@media screen and (max-width: 1200px) {\n  .welcome {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .welcome {\n    width: 95%;\n  }\n  .welcome h2 {\n    font-size: 25px;\n  }\n}\n@media screen and (max-width: 800px) {\n  .welcome {\n    width: 95%;\n  }\n}\n/* welcome styling end */\n/* initiative styling start */\n.init {\n  width: 85%;\n  margin: auto;\n}\n.head h2 {\n  text-align: center;\n  text-transform: uppercase;\n  font-family: serif;\n  font-weight: 550;\n  color: #ce1126;\n}\n.head h2::after {\n  content: \"\";\n  width: 60px;\n  margin: 5px auto;\n  border-bottom: 4px solid #15489c;\n  display: block;\n}\n.initiative h3 {\n  font-family: serif;\n  color: #15489c;\n  font-weight: 550;\n}\n.initiative p {\n  text-align: justify;\n  font-size: 17px;\n}\n.imageSlider img {\n  height: 385px;\n}\n.init .carousel-control-next,\n.init .carousel-control-prev {\n  display: none;\n}\n\n.init .carousel-indicators [data-bs-target] {\n  width: 12px;\n  height: 12px;\n  background-color: #15489c;\n}\n.init .carousel-indicators {\n  bottom: -70px;\n}\n@media screen and (max-width: 1200px) {\n  .init {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .init {\n    width: 95%;\n  }\n}\n@media screen and (max-width: 800px) {\n  .init {\n    width: 95%;\n  }\n  .imageSlider img {\n    height: 253px;\n  }\n}\n/* initiative styling end */\n/* profession styling start */\n.profession {\n  width: 85%;\n  margin: auto;\n  background-color: #f2f2f2;\n  overflow-x: hidden;\n}\n\n.ecard {\n  background-color: #fff;\n  padding: 20px;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,\n    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  margin: 0 10px;\n}\n.ecard h3 {\n  font-family: serif;\n  color: #15489c;\n  font-weight: 550;\n}\n.slick-dots {\n  bottom: -25px;\n}\n\n.slick-dots li button:before {\n  width: 10px;\n  height: 10px;\n  content: \"\";\n  display: block;\n  background-color: #ce1126;\n}\n@media screen and (max-width: 1200px) {\n  .profession {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .profession {\n    width: 95%;\n  }\n}\n\n/* profession styling end */\n/* crs styling start */\n\n.crs {\n  width: 85%;\n  margin: auto;\n  position: relative;\n}\n.crss {\n  background-color: #284e9c;\n}\n.crs h2 {\n  color: #284e9c;\n  border-bottom: 2px solid #ce1126;\n}\n.crs-flex {\n  display: flex !important;\n}\n.crs .image {\n  width: 60%;\n  margin: auto;\n}\n.crs .image img {\n  width: 100%;\n  height: 325px;\n}\n.crs .content {\n  width: 40%;\n  margin: auto;\n  padding: 20px 30px;\n  background-color: #15489c;\n}\n.crs .content h3 {\n  color: #fff;\n  text-align: center;\n}\n.crs .content p {\n  text-align: justify;\n  color: #fff;\n  font-size: 16px;\n}\n.crs .content button {\n  border: none;\n  color: #15489c;\n  padding: 3px 7px;\n}\n.crsicon {\n  display: flex;\n  justify-content: end;\n}\n.crsicon .icon {\n  height: 45px;\n  width: 45px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  text-align: center;\n  margin: 0px 7px;\n}\n.crsicon .cicon {\n  color: #fff;\n  margin-top: 12px;\n}\n.crsicon .cicon {\n  font-size: 18px;\n}\n.crs .carousel-control-next-icon,\n.crs .carousel-control-prev-icon,\n.carousel_hero .carousel-control-next-icon,\n.carousel_hero .carousel-control-prev-icon {\n  display: none;\n}\n.crs .carousel-indicators [data-bs-target] {\n  width: 10px;\n  height: 10px;\n}\n.crs .carousel-indicators button {\n  /* position: relative; */\n  background-color: #ce1126;\n}\n.crs .carousel-indicators {\n  position: absolute;\n  top: -55px;\n  left: 65%;\n}\n\n@media screen and (max-width: 1200px) {\n  .crs {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .crs {\n    width: 95%;\n  }\n  .crs .image {\n    width: 55%;\n  }\n  .crs .content {\n    width: 45%;\n  }\n}\n@media screen and (max-width: 800px) {\n  .crs {\n    width: 95%;\n  }\n  .crs .carousel-indicators {\n    left: 55%;\n  }\n}\n@media screen and (max-width: 760px) {\n  .crs-flex {\n    display: flex !important;\n    flex-direction: column;\n  }\n  .crs .image {\n    width: 100%;\n  }\n  .crs .content {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 500px) {\n  .crs .image {\n    height: 200px;\n  }\n  .crs .image img {\n    height: 200px;\n  }\n}\n\n/* crs styling end */\n/* sci styling start */\n.sci {\n  width: 85%;\n  margin: auto;\n  background-color: #f2f2f2;\n}\n.sci .nav {\n  background-color: #15489c !important;\n  width: 100%;\n}\n\n.sci .nav-item {\n  width: 150px !important;\n  border-left: 1px solid #fff;\n  border-right: 1px solid #fff;\n}\n\n.sci .nav-pills .nav-link.active,\n.sci .nav-pills .show > .nav-link {\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #ce1126 !important;\n}\n.sci .nav-pills {\n  --bs-nav-pills-border-radius: 0 !important;\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #ce1126 !important;\n}\n.sci .nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: 20px !important;\n  /* font-weight: 550 !important; */\n  color: #fff !important;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n\n.view_more {\n  text-align: center;\n}\n.view_more button {\n  border: none;\n  background-color: #15489c;\n  color: #fff;\n  border: none;\n  padding: 10px 25px;\n}\n@media screen and (max-width: 1200px) {\n  .sci {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .sci {\n    width: 95%;\n  }\n}\n@media screen and (max-width: 800px) {\n  .sci {\n    width: 95%;\n  }\n  .sci h2 {\n    font-size: 22px;\n  }\n}\n@media screen and (max-width: 500px) {\n  .sci h2 {\n    font-size: 19px;\n  }\n  .sci .nav {\n    --bs-nav-link-padding-x: 0.4rem;\n    --bs-nav-link-padding-y: 0.3rem;\n  }\n\n  .sci .nav-item {\n    width: 114px !important;\n  }\n  .sci .nav-link {\n    font-size: 18px !important;\n  }\n}\n\n/* sci styling end */\n/* news styling start */\n\n.news-room {\n  background-color: #fff !important;\n  width: 95%;\n  margin: auto;\n}\n.news-room h3 {\n  text-align: center;\n  color: #ce1126;\n  font-weight: bold;\n}\n.news-room h3::after {\n  content: \"\";\n  width: 70px;\n  margin: 5px auto 0px auto;\n  display: block;\n  border-bottom: 3.5px solid #15489c;\n}\n.news-room .news-card {\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n}\n.news-room .news-card img {\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n}\n.news-room .news-content {\n  padding: 10px;\n}\n\n.news-room .news-card h5 {\n  color: #284e9c;\n}\n\n/* news styling end */\n\n/* get involved styling start */\n.get_involved {\n  width: 85%;\n  margin: auto;\n  background-color: #f2f2f2;\n}\n.get_involved .form {\n  width: 65%;\n  margin: auto;\n}\n.get_involved .head {\n  text-align: center;\n}\n.get_involved .head h2 {\n  font-size: 22px;\n}\n.get_involved .head h3 {\n  font-size: 30px;\n  color: #15489c;\n  font-weight: 550;\n}\n.get_involved .head h2::after {\n  border-bottom: 2px solid #ce1126;\n}\n\n.get_involved .input_check .input {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  justify-content: space-between;\n}\n.get_involved .input_check .checkbox {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  padding: 0px 10px;\n  justify-content: space-between;\n  margin: auto;\n}\n\n.get_involved input[type=\"text\"] {\n  width: 100%;\n  margin: auto 0px;\n  padding: 9px 10px;\n}\n\n.get_involved .input_label {\n  margin-bottom: 10px;\n  margin: 10px 5px;\n}\n.get_involved input::placeholder {\n  text-transform: uppercase;\n  font-size: 18px;\n}\n.get_involved label {\n  padding-left: 5px;\n  color: #595757;\n  font-weight: 550;\n}\n.get_involved .agree {\n  font-weight: 500 !important;\n  color: #284e9c;\n}\n.register_button {\n  text-align: center;\n}\n.register_button button {\n  width: 80%;\n  margin: auto;\n  border: none;\n  font-size: 20px;\n  text-transform: uppercase;\n  padding: 8px;\n  background: #284e9c;\n  color: #fff;\n  font-weight: 550;\n}\n@media screen and (max-width: 1200px) {\n  .get_involved {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .get_involved {\n    width: 95%;\n  }\n  .get_involved .form {\n    width: 75%;\n  }\n}\n@media screen and (max-width: 800px) {\n  .get_involved {\n    width: 95%;\n  }\n  .get_involved .form {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 625px) {\n  .get_involved .input_check .input {\n    grid-template-columns: 98%;\n  }\n  .get_involved .input_check .checkbox {\n    grid-template-columns: 100%;\n  }\n  .get_involved .head h3 {\n    font-size: 20px;\n    color: #15489c;\n  }\n  .get_involved input::placeholder {\n    font-size: 14px;\n  }\n  .get_involved label {\n    font-size: 14px;\n  }\n  .register_button button {\n    font-size: 16px;\n  }\n}\n\n/* get involved styling end */\n/* footer stying start */\n.footer {\n  background-color: rgb(8, 69, 112);\n}\n.footer-section {\n  display: flex;\n  flex-wrap: wrap;\n}\n.footer-section h4 {\n  font-size: 30px;\n  font-family: \"Franklin Gothic Medium\", \"Arial Narrow\", Arial, sans-serif;\n  color: rgb(22 98 154);\n  font-weight: bold;\n  color: #fff;\n}\n.footer-section ul li {\n  list-style: none;\n  font-size: 17px;\n  font-weight: 550;\n  color: #fff;\n}\n.footer-social-icon {\n  display: flex;\n}\n.footer-social-icon li {\n  height: 40px;\n  width: 50px;\n  background-color: rgb(0 114 188);\n  margin: 10px;\n  color: #fff;\n  list-style: none;\n  text-align: center;\n  padding-top: 4px;\n  cursor: pointer;\n}\n.footer-social-icon li:hover {\n  background-color: #fff;\n  color: #000;\n}\n.copy-right {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.powered_by a {\n  color: rgb(0 114 188);\n  text-decoration: none;\n}\n.footer-logo h2 {\n  color: #fff;\n  padding-left: 30px;\n}\n@media screen and (max-width: 940px) {\n  .footer-section {\n    justify-content: center;\n  }\n  .footer-contact {\n    text-align: center;\n  }\n  .footer-social-icon {\n    justify-content: space-evenly;\n  }\n}\n\n/* About section styling start */\n\n.about {\n  width: 85%;\n  margin: auto;\n}\n.about-head {\n  display: flex;\n}\n.about-head h3 {\n  font-size: 35px;\n  color: #15489c;\n}\n.about-head p {\n  font-size: 15px;\n  color: #ce1126;\n}\n.about-head .star_icon .star {\n  font-size: 15px;\n  color: #ce1126;\n  margin-top: 17px;\n}\n.about .content p {\n  font-size: 16px;\n  text-align: justify;\n}\n.about .a_video {\n  height: 500px;\n}\n\n/* contact section styling start */\n.contact_section {\n  width: 85%;\n  margin: auto;\n}\n.contact_section h2 {\n  font-size: 27px;\n  text-align: center;\n  color: #15489c;\n  font-weight: 650;\n}\n.contact_section h2::after {\n  content: \"\";\n  width: 50px;\n  border-bottom: 3px solid #ce1126;\n  display: block;\n  margin: 5px auto;\n}\n.contact_section input,\n.contact_section textarea {\n  padding: 8px 10px;\n  border: 1px solid #15489c;\n  outline: none;\n}\n.contact_section .input_contact_label {\n  padding: 10px 0px;\n}\n.contact_section label {\n  font-size: 15px;\n  color: #4a4949;\n  margin-bottom: 10px;\n}\n.contact_button button {\n  border: none;\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: 550;\n  padding: 10px 30px;\n  background-color: #15489c;\n  color: #fff;\n}\n\n@media screen and (max-width: 1200px) {\n  .about,\n  .contact_section {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1095px) {\n  .about,\n  .contact_section {\n    width: 95%;\n  }\n}\n@media screen and (max-width: 800px) {\n  .about,\n  .contact_section {\n    width: 97%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
